document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.fade-in-on-scroll');

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate');
        observer.unobserve(entry.target); // Remove observer once animated
      }
    });
  }, {
    threshold: 0.6
  });

  elements.forEach(el => observer.observe(el));
});